import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppShell } from 'shared/components/AppShell';
import { OPERATIONS_NAV } from '../../navigation';

/**
 * Operations area shell: navy header + operations sidebar, wrapping every
 * operations route. Mirrors aligned's `OperationsHomeLayoutView` (persistent
 * header + sidebar around a swapping content area) and matches AdminLayout's
 * structure. Access is gated at the route (`requireRole="operations"`), so —
 * like AdminLayout — there is no account/org model to resolve here and thus no
 * loading/error state.
 *
 * All three operations tools (Campaigns, Expert Pools, Applications) are
 * data-dense desktop layouts, so the shell always runs full-width.
 */
export function OperationsLayout() {
  return (
    <AppShell nav={OPERATIONS_NAV} fullWidth>
      <Outlet />
    </AppShell>
  );
}
